import { Button } from '@chakra-ui/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { gql, useLazyQuery } from '@apollo/client';
const EMAIL_FORGOT = gql`
  query Query($email: String!, $mailersend: mailersendValidationInput) {
    exploreruser_ForgotPassword(email: $email, mailersend: $mailersend)
  }
`;

const ResetPassword = () => {
  const { getValues } = useFormContext();
  const email = getValues('email');
  const [resetPassword, { data, loading, error }] = useLazyQuery(EMAIL_FORGOT);

  return (
    <Button
      onClick={() =>
        resetPassword({
          variables: {
            email: email,
            mailersend: {
              callbackUrl:
                `${process.env.REACT_APP_FE_URL}/reset-password/explorer`,
              templateAlias: 'resetPassword',
            },
          },
        })
      }
    >
      Send Reset Password Link
    </Button>
  );
};

export default ResetPassword;
